<ng-container *ngIf="mode === 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <div class="flex-row flex-wrap" [ngSwitch]="multiple">

        <ng-container *ngSwitchCase="true">

            <ng-container *ngIf="control?.value?.length; then itemsTemplate; else notSetTemplate"></ng-container>

            <ng-template #itemsTemplate>
                <picker-item-standalone *ngFor="let item of control?.value" [text]="$safeNavigationMigration(item?.name)" [itemStyle]="PickerItemStyle.COLOR_LEFT"></picker-item-standalone>
            </ng-template>

            <ng-template #notSetTemplate>
                <picker-item-standalone></picker-item-standalone>
            </ng-template>

        </ng-container>

        <ng-container *ngSwitchCase="false">
            <picker-item-standalone [text]="$safeNavigationMigration(control?.value?.name)" [itemStyle]="PickerItemStyle.COLOR_LEFT"></picker-item-standalone>
        </ng-container>

    </div>

</ng-template>
<ng-template #edit>

    <ng-select [searchFn]="searchFn" [appendTo]="appendTo" [items]="data$ | async" bindLabel="name" [placeholder]="placeholder" [searchable]="true" [multiple]="multiple" [closeOnSelect]="closeOnSelect" [hideSelected]="hideSelected" [formControl]="control">
        <ng-template ng-option-tmp let-item="item">
            <picker-item-standalone [text]="$safeNavigationMigration(item?.name)" [itemStyle]="PickerItemStyle.DEFAULT"></picker-item-standalone>
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <div class="view-template">
                <picker-item-standalone [text]="$safeNavigationMigration(item?.name)" [itemStyle]="PickerItemStyle.DEFAULT"></picker-item-standalone>
                <span *ngIf="multiple === true" class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>